import { ChapterFill18Icon } from "@vygruppen/spor-icon-react";
import type { ColorScheme } from "features/CenterContent/RoleContent/EventHandling/components/InfraEventCard/types";
import { FC } from "react";
import { HStack, Text } from "shared/components/Spor";

type ActionCardInfoProps = {
  actionCardType?: string;
  actionCardLabel?: string;
  colorScheme: ColorScheme;
};

export const ActionCardInfo: FC<ActionCardInfoProps> = ({
  actionCardType,
  actionCardLabel,
  colorScheme,
}) => {
  if (!actionCardType) {
    return null;
  }

  return (
    <HStack>
      <ChapterFill18Icon color={colorScheme.textColorSecondary} />
      <Text
        variant="xs"
        color={colorScheme.textColorSecondary}
        fontWeight="bold"
      >
        Aksjonskort {actionCardLabel ?? actionCardType}
      </Text>
    </HStack>
  );
};
